module.exports = __webpack_public_path__ + "e7ce8213969afb35b24914c621ff4bd3.svg";